import React from "react";
import { Card, CardContent, Typography, Avatar } from "@mui/material";

export default function StaffCard({ name, role, joinDate, profilePic, score }) {
  return (
    <Card
      variant="outlined"
      sx={{
        display: "flex",
        alignItems: "center",
        borderRadius: 2,
      }}
    >
      <Avatar
        src={profilePic}
        alt={name}
        sx={{ width: 64, height: 64, marginRight: 2 }}
      />
      <CardContent>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          {name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {role}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          سن: {joinDate}
        </Typography>
        <Typography variant="h6" color="text.secondary" fontSize={13}>
          امتیاز: {score}
        </Typography>
      </CardContent>
    </Card>
  );
}
